module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATJJREFUeNpiYAACs+kP/zOBCCA7ESCAQLwEkCgTEOeDRAECiBEqMp8BAjYwwjRBBRgAAogBJgDE+0FsRnRZJgY0gC5wASCAYIa+B1ICDJhAEeZCdMlEKH0fZOQBKOcDEAdC2TB3M8CsUACpRrf/VKa8IUAAMSL5BeQPB5gVQMkFMH9h0w22EqhIkAmHJAgIgMKRCYfkAphjmdC8BZNMgHFYkLzlCMTxyJKgIAApuADEBkC8H90eoCMdmUB+hSrCCGYQARBgyOEA8u56qGn4AMiwQKDBD5BD+jwRGhmwxgRaDBACoNCyRwoIcCA4kKBxPpq4A3pEfYAG9wUkjQugGhOwmcwCVQQzWQAaHSCDNmCxEcNlyMn1PI5cgQ2ALDAExQQjugw0I8djCRtQxlkIS+YwAADj8WWCYjxJsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/yugaon.png
// module id = Fatr
// module chunks = 1